import { Component, OnInit, AfterViewInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { PATH_CONSIGNA_DETAIL, PATH_CUENTA_DETAIL, PATH_CONTACTO_DETAIL, PATH_COLABORADOR_DETAIL, PATH_NEGOCIO_DETAIL, PATH_AGRIS_COTIZACION_DETALLE } from '../../../navigation/navigation.module';
import { CommonService, NEGOCIO_TYPE_DISPO, NEGOCIO_TYPE_FORWARD } from '../../../services';
import { Router } from '@angular/router';

import { Observable } from 'rxjs/Observable';

export const ENTITY_TYPE_CONSIGNA = 'Consigna';
export const ENTITY_TYPE_NEGOCIO = 'Negocio';
export const ENTITY_TYPE_CUENTA = 'Cuenta';
export const ENTITY_TYPE_COLABORADOR = 'Colaborador';
export const ENTITY_TYPE_CONTACTO = 'Contacto';
export const ENTITY_TYPE_PROFILE = 'Perfil';
export const ENTITY_TYPE_ORDEN = 'Orden';
export const ENTITY_TYPE_INTENCION = 'Intencion';
export const ENTITY_TYPE_CONTRATITO = 'Contratito';
export const ENTITY_TYPE_CANJE = 'Canje';
export const ENTITY_TYPE_AVISO_GENERADO = 'Aviso Genuino (Acopios)';
export const ENTITY_TYPE_NEGOCIO_OLVIDADO = 'Negocio Olvidado';

@Component({
  selector: 'app-activity-list',
  templateUrl: './activity-list.component.html',
  styleUrls: ['./activity-list.component.scss']
})
export class ActivityListComponent implements OnInit, AfterViewInit, OnDestroy {

  private _activities;

  @Input()
  set activities(activities) {

    this._activities = activities ? activities.map(value => {
      const isCurrentUser = this.userId === value.ActivityObject.UserAccionID;
      value.ActivityObject.UserNameAction = value.ActivityObject.UserAccionID === 0 ? 'El sistema' : value.ActivityObject.UserNameAction;
      value.ActivityObject.isCurrentUser = isCurrentUser;
      return value;
    }) : [];
    this.bottomReached = false;
  }

  @Input() dateInNewLine = false;
  @Input() parentComponentEntity;
  @Input() parentComponentEntityId;

  @Output() onBottomReached = new EventEmitter<boolean>();
  bottomReached = false;

  @Input() highlightUnread = false;

  @Input() shortNegociosText = false;

  ENTITY_TYPE_CONSIGNA = ENTITY_TYPE_CONSIGNA;
  ENTITY_TYPE_CUENTA = ENTITY_TYPE_CUENTA;
  ENTITY_TYPE_COLABORADOR = ENTITY_TYPE_COLABORADOR;
  ENTITY_TYPE_CONTACTO = ENTITY_TYPE_CONTACTO;
  ENTITY_TYPE_PROFILE = ENTITY_TYPE_PROFILE;

  // Negocios
  ENTITY_TYPE_ORDEN = ENTITY_TYPE_ORDEN;
  ENTITY_TYPE_INTENCION = ENTITY_TYPE_INTENCION;
  ENTITY_TYPE_NEGOCIO = ENTITY_TYPE_NEGOCIO;

  ACTION_TYPE_CREATE = 'Creacion';
  ACTION_TYPE_EDIT = 'Edicion';
  ACTION_TYPE_DELETE = 'Eliminacion';
  ACTION_TYPE_ACTIVATE = 'Activacion';
  ACTION_TYPE_DEACTIVATE = 'Desactivacion';
  ACTION_TYPE_FINISH = 'Finalizacion';
  ACTION_TYPE_COMMENT = 'Comento';
  ACTION_TYPE_EDIT_COMMENT = 'Edicion Comentario';
  ACTION_TYPE_DELETE_COMMENT = 'Eliminacion comentario';
  ACTION_TYPE_ADD_CONTACT_TO = 'Alta Contacto';
  ACTION_TYPE_EDIT_CONTACT = 'Edicion de Contacto';
  ACTION_TYPE_DELETE_CONTACT = 'Eliminacion de Contacto';
  ACTION_TYPE_ADD_LABEL_TO = 'Adicion de Etiqueta';
  ACTION_TYPE_DELETE_LABEL = 'Eliminacion de Etiqueta';
  ACTION_TYPE_CALL = 'Llamada';
  ACTION_TYPE_EMAIL = 'Envio de email';
  ACTION_TYPE_CHANGE_AVATAR = 'Cambio Avatar';
  ACTION_TYPE_CHANGE_PHONE_NUMBER = 'Edicion Telefono';

  // Negocios
  ACTION_TYPE_MATCH_INTENCION = 'La Intención fue matcheada';
  ACTION_TYPE_MATCH_ORDEN = 'La Orden fue matcheada';
  ACTION_TYPE_VENCIMIENTO_NEGOCIO = 'Vencimiento Negocio';
  ACTION_TYPE_AUTORIZACION = 'Solicitud de autorización';
  ACTION_TYPE_NO_AUTORIZADO = 'No autorizado';
  ACTION_TYPE_VENCIDA_INTENCION = 'Vencimiento Intencion';
  ACTION_TYPE_VENCIMIENTO = 'Vencido';

  ACTION_TYPE_AUTORIZADO = 'Autorizado';
  ACTION_TYPE_REACTIVADO = 'Reactivado';
  ACTION_TYPE_CHANGE_TYPE_TO_ORDEN = 'Cambio a orden';
  ACTION_TYPE_CHANGE_TYPE_TO_INTENCION = 'Cambio a intención';
  ACTION_TYPE_SET_PRICE = 'Seteo de precio especial';
  ACTION_TYPE_CANCELED = 'Anulada';
  ACTION_TYPE_CONFIRMED = 'Confirmada';
  ACTION_TYPE_REJECTED_SET_PRICE = 'Precio especial rechazado';
  ACTION_TYPE_CREATE_PRICE = 'Carga de Precio';
  ACTION_TYPE_UPDATE_PRICE = 'Actualizacion de Precio';

  ACTION_TYPE_AVISO_GENERADO = 'Aviso Generado';
  ACTION_TYPE_NEGOCIO_FINALIZADO = 'Finalizado';
  ACTION_TYPE_NEGOCIO_GENERANDO_AVISO = 'En proceso de generacion de aviso';
  ACTION_TYPE_NEGOCIO_AVISO_CANCELADO = 'Aviso Cancelado';

  // Usuarios Agro
  ACTION_TYPE_EDITAR_USUARIO_AGRO = 'Editar Usuario';
  ACTION_TYPE_ACTIVAR_USUARIO_AGRO = 'Activar Usuario';
  ACTION_TYPE_DESCONOCER_USUARIO_AGRO = 'Desconocer Usuario';

  // Acciones de AGRIS
  ACTION_TYPE_AGRIS_COTIZACION_CREAR = "Crear Cotización Agris";
  ACTION_TYPE_AGRIS_COTIZACION_EDITAR = "Editar Cotización Agris";
  ACTION_TYPE_AGRIS_COTIZACION_GUARDAR = "Guardar Cotización Agris";
  ACTION_TYPE_AGRIS_COTIZACION_CONFIRMAR = "Confirmar Cotización Agris";
  ACTION_TYPE_AGRIS_COTIZACION_PERDER = "Perder Cotización Agris";
  ACTION_TYPE_AGRIS_COTIZACION_RENOVAR = "Renovar Cotización Agris";
  ACTION_TYPE_AGRIS_COTIZACION_VENCER = "Vencer Cotización Agris";

  // Entidades de Agris
  ENTITY_TYPE_AGRIS_COTIZACION = "Cotización Agris";


  userId: string;

  private scrollSubscriber;

  constructor(private router: Router, private commonService: CommonService) {
    this.userId = localStorage.getItem('userId');
  }

  ngOnInit() {
  }

  getActionText(ActivityObject) {
    const actionType = ActivityObject.Accion;
    const entityType = ActivityObject.Entidad;

    //NUEVO
    // Agris
    if (entityType === this.ENTITY_TYPE_AGRIS_COTIZACION) {
      switch (actionType) {
        case this.ACTION_TYPE_AGRIS_COTIZACION_CREAR:
          return ActivityObject.isCurrentUser ? 'Creaste' : 'creó'
        case this.ACTION_TYPE_AGRIS_COTIZACION_EDITAR:
          return ActivityObject.isCurrentUser ? 'Editaste' : 'editó'
        case this.ACTION_TYPE_AGRIS_COTIZACION_GUARDAR:
          return ActivityObject.isCurrentUser ? 'Guardaste' : 'guardó'
        case this.ACTION_TYPE_AGRIS_COTIZACION_CONFIRMAR:
          return ActivityObject.isCurrentUser ? 'Confirmaste' : 'confirmó'
        case this.ACTION_TYPE_AGRIS_COTIZACION_PERDER:
          return ActivityObject.isCurrentUser ? 'Marcaste como perdida' : 'marcó como perdida'
        case this.ACTION_TYPE_AGRIS_COTIZACION_RENOVAR:
          return ActivityObject.isCurrentUser ? 'Renovaste' : 'renovó'
        case this.ACTION_TYPE_AGRIS_COTIZACION_VENCER:
          return ActivityObject.isCurrentUser ? 'Marcaste como vencida' : 'marcó como vencida'
      }
    }

    switch (actionType) {
      case this.ACTION_TYPE_MATCH_INTENCION:
        return 'matcheó';
      case this.ACTION_TYPE_MATCH_ORDEN:
        return 'matcheó';
      case this.ACTION_TYPE_VENCIMIENTO_NEGOCIO:
        return 'Venció el plazo de la confirmación manual';
      // case this.ACTION_TYPE_NO_AUTORIZADO:
      //   return 'No autorizó';
      case this.ACTION_TYPE_VENCIDA_INTENCION:
        return 'La Intención se venció';
      // case this.ACTION_TYPE_AUTORIZADO:
      //   return 'La Intención se autorizó';
      // case this.ACTION_TYPE_REACTIVADO:
      //   return 'Reactivado';
      // case this.ACTION_TYPE_CHANGE_TYPE_TO_ORDEN:
      //   return 'Cambio a orden';
      // case this.ACTION_TYPE_CHANGE_TYPE_TO_INTENCION:
      //   return 'Cambio a intención';
    }

    if (ActivityObject.isCurrentUser) {
      switch (actionType) {
        case this.ACTION_TYPE_CREATE:
          switch (entityType) {
            case this.ENTITY_TYPE_CONSIGNA:
            case this.ENTITY_TYPE_NEGOCIO:
              return 'Creaste';
            case this.ENTITY_TYPE_CUENTA:
            case this.ENTITY_TYPE_COLABORADOR:
              return 'Diste de alta';
          }
          break;
        case this.ACTION_TYPE_SET_PRICE:
          return 'Agregaste precio especial a';
        case this.ACTION_TYPE_NO_AUTORIZADO:
          return 'No autorizaste';
        case this.ACTION_TYPE_AUTORIZADO:
          return 'Autorizaste';
        case this.ACTION_TYPE_REACTIVADO:
          return 'Reactivaste';
        case this.ACTION_TYPE_CHANGE_TYPE_TO_ORDEN:
          return 'Cambiaste a orden';
        case this.ACTION_TYPE_CHANGE_TYPE_TO_INTENCION:
          return 'Cambiaste a intención';
        case this.ACTION_TYPE_EDIT:
          return 'Editaste';
        case this.ACTION_TYPE_DELETE:
          return 'Eliminaste';
        case this.ACTION_TYPE_ACTIVATE:
          return 'Reactivaste';
        case this.ACTION_TYPE_DEACTIVATE:
          return 'Desactivaste';
        case this.ACTION_TYPE_FINISH:
          return 'Finalizaste';
        case this.ACTION_TYPE_COMMENT:
          return 'Comentaste';
        case this.ACTION_TYPE_EDIT_COMMENT:
          return 'Editaste 1 comentario de';
        case this.ACTION_TYPE_DELETE_COMMENT:
          return 'Eliminaste un comentario de';
        case this.ACTION_TYPE_ADD_CONTACT_TO:
          return 'Agregaste 1 contacto a';
        case this.ACTION_TYPE_EDIT_CONTACT:
          return 'Editaste 1 contacto de';
        case this.ACTION_TYPE_DELETE_CONTACT:
          return 'Eliminaste 1 contacto de';
        case this.ACTION_TYPE_ADD_LABEL_TO:
          return 'Agregaste 1 etiqueta a';
        case this.ACTION_TYPE_CALL:
          return 'Llamaste a';
        case this.ACTION_TYPE_EMAIL:
          return 'Enviaste 1 email a';
        case this.ACTION_TYPE_DELETE_LABEL:
          return 'Eliminaste 1 etiqueta de';
        case this.ACTION_TYPE_CHANGE_AVATAR:
          return 'Cambiaste tu avatar';
        case this.ACTION_TYPE_CHANGE_PHONE_NUMBER:
          return 'Cambiaste tu número de teléfono';
        case this.ACTION_TYPE_VENCIMIENTO:
          return 'venció';
        case this.ACTION_TYPE_AUTORIZACION:
          return 'Solicitaste Autorización para';
        case this.ACTION_TYPE_CANCELED:
          return 'Anulaste';
        case this.ACTION_TYPE_CONFIRMED:
          return 'Confirmaste';
        case this.ACTION_TYPE_REJECTED_SET_PRICE:
          return 'Rechazaste el precio especial en';
        case this.ACTION_TYPE_UPDATE_PRICE:
          return 'Actualizaste el precio de';
      }
    } else {
      switch (actionType) {
        case this.ACTION_TYPE_CREATE:
          switch (entityType) {
            case this.ENTITY_TYPE_CONSIGNA:
            case this.ENTITY_TYPE_ORDEN:
            case this.ENTITY_TYPE_INTENCION:
            case this.ENTITY_TYPE_NEGOCIO:
              return 'creó';
            case this.ENTITY_TYPE_CUENTA:
            case this.ENTITY_TYPE_COLABORADOR:
              return 'dio de alta';
          }
          break;
        case this.ACTION_TYPE_SET_PRICE:
          return 'agregó precio especial a';
        case this.ACTION_TYPE_NO_AUTORIZADO:
          return 'no autorizó';
        case this.ACTION_TYPE_AUTORIZADO:
          return 'autorizó';
        case this.ACTION_TYPE_REACTIVADO:
          return 'reactivó';
        case this.ACTION_TYPE_CHANGE_TYPE_TO_ORDEN:
          return 'cambio a orden';
        case this.ACTION_TYPE_CHANGE_TYPE_TO_INTENCION:
          return 'cambio a intención';
        case this.ACTION_TYPE_EDIT:
          return 'editó';
        case this.ACTION_TYPE_DELETE:
          return 'eliminó';
        case this.ACTION_TYPE_ACTIVATE:
          return 'reactivó';
        case this.ACTION_TYPE_DEACTIVATE:
          return 'desactivó';
        case this.ACTION_TYPE_FINISH:
          return 'finalizó';
        case this.ACTION_TYPE_COMMENT:
          return 'comentó';
        case this.ACTION_TYPE_EDIT_COMMENT:
          return 'editó 1 comentario de';
        case this.ACTION_TYPE_DELETE_COMMENT:
          return 'eliminó 1 comentario de';
        case this.ACTION_TYPE_ADD_CONTACT_TO:
          return 'agregó 1 contacto a';
        case this.ACTION_TYPE_EDIT_CONTACT:
          return 'editó 1 contacto de';
        case this.ACTION_TYPE_DELETE_CONTACT:
          return 'eliminó 1 contacto de';
        case this.ACTION_TYPE_ADD_LABEL_TO:
          return 'agregó 1 etiqueta a';
        case this.ACTION_TYPE_CALL:
          return 'llamó a';
        case this.ACTION_TYPE_EMAIL:
          return 'envió 1 email a';
        case this.ACTION_TYPE_DELETE_LABEL:
          return 'eliminó 1 etiqueta de';
        case this.ACTION_TYPE_CHANGE_AVATAR:
          return 'cambió su avatar';
        case this.ACTION_TYPE_CHANGE_PHONE_NUMBER:
          return 'cambió su número de teléfono';
        case this.ACTION_TYPE_VENCIMIENTO:
          return 'venció';
        case this.ACTION_TYPE_AUTORIZACION:
          return 'solicitó Autorización para';
        case this.ACTION_TYPE_CANCELED:
          return 'anuló';
        case this.ACTION_TYPE_CONFIRMED:
          return 'confirmó';
        case this.ACTION_TYPE_REJECTED_SET_PRICE:
          return 'Rechazó el precio especial en';
        case this.ACTION_TYPE_AVISO_GENERADO:
          return 'generó el aviso de';
        case this.ACTION_TYPE_NEGOCIO_FINALIZADO:
          return 'finalizó';
        case this.ACTION_TYPE_NEGOCIO_GENERANDO_AVISO:
          return 'esta generando el aviso de';
        case this.ACTION_TYPE_NEGOCIO_AVISO_CANCELADO:
          return 'canceló el aviso de';
        case this.ACTION_TYPE_UPDATE_PRICE:
          return 'actualizó el precio de';
        case this.ACTION_TYPE_EDITAR_USUARIO_AGRO:
          return 'editó al usuario Agro';
        case this.ACTION_TYPE_DESCONOCER_USUARIO_AGRO:
          return 'desconoció al usuario Agro';
        case this.ACTION_TYPE_ACTIVAR_USUARIO_AGRO:
          return 'activó al usuario Agro';
      }
    }
  }

  buildNegocioEntityString(ActivityObject) {
    const cliente = ActivityObject.Cliente && ActivityObject.Cliente.FullName;
    const producto = ActivityObject.Negocio && ActivityObject.Negocio.substring(ActivityObject.Negocio.lastIndexOf(', ')+2);
    const negocio = !ActivityObject.Posicion ? NEGOCIO_TYPE_DISPO : NEGOCIO_TYPE_FORWARD;
    const entrega = !ActivityObject.Posicion ?
                      ActivityObject.Entrega && ActivityObject.Entrega.Entrega :
                      this.commonService.getPosicionShortName(ActivityObject.Posicion && ActivityObject.Posicion.Posicion);
    const base = ActivityObject.PrecioBase;
    const moneda = ActivityObject.Moneda && ActivityObject.Moneda.Simbolo;

    return [cliente, producto[0].toUpperCase() +  producto.substring(1), negocio, entrega, base, moneda].join(' ');
  }

  getEntityText(ActivityObject) {

    const actionType = ActivityObject.Accion;
    const entityType = ActivityObject.Entidad;
    // debugger;
    /** Parent component is Consigna Detail, Cuenta Detail, etc. and this activity is related to the same entity */
    if (this.parentComponentEntity
      && this.parentComponentEntityId
      && this.parentComponentEntity === entityType) {

      switch (entityType) {
        case this.ENTITY_TYPE_CONSIGNA:
          if (this.parentComponentEntityId === ActivityObject.ConsignaID) {
            return 'esta consigna';
          }
        case this.ENTITY_TYPE_CUENTA:
          if (this.parentComponentEntityId === ActivityObject.CuentaID) {
            return 'esta cuenta';
          }
        case this.ENTITY_TYPE_COLABORADOR:
          if (this.parentComponentEntityId === ActivityObject.UserId) {
            return 'este colaborador';
          }
        case this.ENTITY_TYPE_CONTACTO:
          if (this.parentComponentEntityId === ActivityObject.ClientContactId) {
            return 'este contacto';
          }
        case this.ENTITY_TYPE_NEGOCIO:
          switch (ActivityObject.NegocioTipo) {
            case ENTITY_TYPE_ORDEN:
              return 'esta Orden';
            case ENTITY_TYPE_INTENCION:
              return 'esta Intención';
            case ENTITY_TYPE_CONTRATITO:
              return 'este Contratito';
            case ENTITY_TYPE_CANJE:
              return 'este Canje';
            case ENTITY_TYPE_AVISO_GENERADO:
              return 'este Aviso Genuino (Acopios)';
            case ENTITY_TYPE_NEGOCIO_OLVIDADO:
              return 'este Negocio Olvidado';
          }
          break;
      }
    }

    switch (entityType) {
      case this.ENTITY_TYPE_AGRIS_COTIZACION:
        return `la cotización ${ActivityObject.Cot_ID}`;
      case this.ENTITY_TYPE_CONSIGNA:
        return ActivityObject.ConsignaTitle;
      case this.ENTITY_TYPE_CUENTA:
        return ActivityObject.CuentaName;
      case this.ENTITY_TYPE_COLABORADOR:
        if (actionType === this.ACTION_TYPE_CALL || actionType === this.ACTION_TYPE_EMAIL) {
          return ActivityObject.UserNameRelated || (
            ActivityObject.Cliente && ActivityObject.Cliente.Contacts && ActivityObject.Cliente.Contacts.length && ActivityObject.Cliente.Contacts[0].FullName
          );
        }
        if (
          actionType === this.ACTION_TYPE_ACTIVAR_USUARIO_AGRO ||
          actionType === this.ACTION_TYPE_EDITAR_USUARIO_AGRO ||
          actionType === this.ACTION_TYPE_DESCONOCER_USUARIO_AGRO
        ) { return ActivityObject.UserNameRelated }
        return ActivityObject.UserFullName;
      case this.ENTITY_TYPE_CONTACTO:
        if (actionType === this.ACTION_TYPE_CALL || actionType === this.ACTION_TYPE_EMAIL) {
          return ActivityObject.ClienteContactoName || (
            ActivityObject.Cliente && ActivityObject.Cliente.Contacts && ActivityObject.Cliente.Contacts.length && ActivityObject.Cliente.Contacts[0].FullName
          );
        }
        return ActivityObject.FullName;
      case this.ENTITY_TYPE_NEGOCIO:
        switch (ActivityObject.NegocioTipo) {
          case ENTITY_TYPE_ORDEN:
            return this.shortNegociosText ? 'esta Orden' : 'la Orden: ' + this.buildNegocioEntityString(ActivityObject);
          case ENTITY_TYPE_INTENCION:
            return this.shortNegociosText ? 'esta Intención' : 'la Intención: ' + this.buildNegocioEntityString(ActivityObject);
          case ENTITY_TYPE_CONTRATITO:
            return this.shortNegociosText ? 'este Contratito' : 'el Contratito: ' + this.buildNegocioEntityString(ActivityObject);
          case ENTITY_TYPE_CANJE:
            return this.shortNegociosText ? 'este Canje' : 'el Canje: ' + this.buildNegocioEntityString(ActivityObject);
          case ENTITY_TYPE_AVISO_GENERADO:
            return this.shortNegociosText ? 'este Aviso Genuino (Acopios)' : 'el Aviso Genuino (Acopios): ' + this.buildNegocioEntityString(ActivityObject);
          case ENTITY_TYPE_NEGOCIO_OLVIDADO:
            return this.shortNegociosText ? 'este Negocio Olvidado' : 'el Negocio Olvidado: ' + this.buildNegocioEntityString(ActivityObject);
        }

    }
    //}
  }

  onSelectEntity(ActivityObject) {
    let path: string;
    const actionType = ActivityObject.Accion;
    const entityType = ActivityObject.Entidad;

    switch (entityType) {
      case this.ENTITY_TYPE_AGRIS_COTIZACION:
        path = `${PATH_AGRIS_COTIZACION_DETALLE}/${ActivityObject.Cot_ID}`
        break;
      case this.ENTITY_TYPE_CONSIGNA:
        path = `${PATH_CONSIGNA_DETAIL}/${ActivityObject.ConsignaID}`;
        break;
      case this.ENTITY_TYPE_CUENTA:
        path = `${PATH_CUENTA_DETAIL}/${ActivityObject.CuentaID}`;
        break;
      case this.ENTITY_TYPE_COLABORADOR:
        if (actionType === this.ACTION_TYPE_CALL || actionType === this.ACTION_TYPE_EMAIL) {
          path = `${PATH_COLABORADOR_DETAIL}/${ActivityObject.UserRelatedID}`;
        } else {
          path = `${PATH_COLABORADOR_DETAIL}/${ActivityObject.UserId}`;
        }
        break;
      case this.ENTITY_TYPE_CONTACTO:
        const id = ActivityObject.ClienteContactoId || (
          ActivityObject.Cliente && ActivityObject.Cliente.Contacts && ActivityObject.Cliente.Contacts.length && ActivityObject.Cliente.Contacts[0].ClientContactId
        );
        path = `${PATH_CONTACTO_DETAIL}/${id}`;
        break;
      case this.ENTITY_TYPE_NEGOCIO:
        path = `${PATH_NEGOCIO_DETAIL}/${ActivityObject.NegocioId}`;
        break;
    }
    this.router.navigate([path]);
  }

  onSelectColaborador(ActivityObject) {
    this.router.navigate([`${PATH_COLABORADOR_DETAIL}/${ActivityObject.UserAccionID}`]);
  }

  public ngAfterViewInit(): void {
    const content = document.querySelector('.mat-drawer-content');

    this.scrollSubscriber = Observable.fromEvent(content, 'scroll')
      .debounceTime(300)
      .map(() => content.scrollTop)
      .subscribe(x => {
        const max = content.scrollHeight - content.clientHeight;

        if (x > max * 0.7) {
          if (!this.bottomReached) {
            this.bottomReached = true;
            this.onBottomReached.emit(true);
          }
        }
      });
  }

  ngOnDestroy(): void {
    if (this.scrollSubscriber) {
      this.scrollSubscriber.unsubscribe();
    }
  }

  getActivityColor(activityObject) {

    if (activityObject.Entidad === this.ENTITY_TYPE_AGRIS_COTIZACION) {
      switch (activityObject.Accion) {
        case this.ACTION_TYPE_AGRIS_COTIZACION_CREAR:
          return "agris-crear";
        case this.ACTION_TYPE_AGRIS_COTIZACION_EDITAR:
          return "agris-editar";
        case this.ACTION_TYPE_AGRIS_COTIZACION_GUARDAR:
          return "agris-guardar";
        case this.ACTION_TYPE_AGRIS_COTIZACION_CONFIRMAR:
          return "agris-confirmar";
        case this.ACTION_TYPE_AGRIS_COTIZACION_PERDER:
          return "agris-perder";
        case this.ACTION_TYPE_AGRIS_COTIZACION_RENOVAR:
          return "agris-renovar";
        case this.ACTION_TYPE_AGRIS_COTIZACION_VENCER:
          return "agris-vencer";
        default:
          return "agris-default";
      }
    }

    switch (activityObject.Accion) {

      case this.ACTION_TYPE_FINISH:
      case this.ACTION_TYPE_ADD_CONTACT_TO:
      case this.ACTION_TYPE_ADD_LABEL_TO:
      case this.ACTION_TYPE_CALL:
      case this.ACTION_TYPE_AUTORIZADO:
      case this.ACTION_TYPE_EMAIL:
      case this.ACTION_TYPE_CONFIRMED:
      case this.ACTION_TYPE_UPDATE_PRICE:
      case this.ACTION_TYPE_ACTIVAR_USUARIO_AGRO:
        case this.ACTION_TYPE_AGRIS_COTIZACION_CREAR:
        return 'green';

      case this.ACTION_TYPE_EDIT:
      case this.ACTION_TYPE_CHANGE_TYPE_TO_INTENCION:
      case this.ACTION_TYPE_CHANGE_TYPE_TO_ORDEN:
      case this.ACTION_TYPE_CHANGE_PHONE_NUMBER:
      case this.ACTION_TYPE_SET_PRICE:
      case this.ACTION_TYPE_REJECTED_SET_PRICE:
      case this.ACTION_TYPE_EDIT_CONTACT:
      case this.ACTION_TYPE_EDIT_COMMENT:
      case this.ACTION_TYPE_AUTORIZACION:
      case this.ACTION_TYPE_EDITAR_USUARIO_AGRO:
      case this.ACTION_TYPE_DESCONOCER_USUARIO_AGRO:
        return 'yellow';

      case this.ACTION_TYPE_COMMENT:
      case this.ACTION_TYPE_ACTIVATE :
      case this.ACTION_TYPE_AVISO_GENERADO:
      case this.ACTION_TYPE_NEGOCIO_FINALIZADO:
      case this.ACTION_TYPE_NEGOCIO_GENERANDO_AVISO:
        return 'blue';

      case this.ACTION_TYPE_DELETE:
      case this.ACTION_TYPE_DELETE_LABEL:
      case this.ACTION_TYPE_DELETE_CONTACT:
      case this.ACTION_TYPE_NO_AUTORIZADO:
      case this.ACTION_TYPE_DELETE_COMMENT:
      case this.ACTION_TYPE_CANCELED:
      case this.ACTION_TYPE_NEGOCIO_AVISO_CANCELADO:
        return 'red';

      case this.ACTION_TYPE_CREATE:
      case this.ACTION_TYPE_REACTIVADO:
      case this.ACTION_TYPE_CHANGE_AVATAR:
        return 'primary';

      case this.ACTION_TYPE_DEACTIVATE:
      case this.ACTION_TYPE_MATCH_INTENCION:
      case this.ACTION_TYPE_MATCH_ORDEN:
        return 'purple';

      case this.ACTION_TYPE_VENCIMIENTO:
        return activityObject.NegocioTipo === ENTITY_TYPE_INTENCION ? 'mid-gray' : 'not-so-gray';
      default:
        return '';
    }
  }

  // No siempre debe mostrarse el nombre del usuario en la actividad en caso de que el usuario actual sea un tercero
  showUsername(activity) {
    return !activity.isCurrentUser;
  }

  isAvisoOrFinalizado(activityObject) {
    return activityObject.Accion === this.ACTION_TYPE_NEGOCIO_FINALIZADO ||
      activityObject.Accion === this.ACTION_TYPE_NEGOCIO_GENERANDO_AVISO ||
      activityObject.Accion === this.ACTION_TYPE_AVISO_GENERADO ||
      activityObject.Accion === this.ACTION_TYPE_NEGOCIO_AVISO_CANCELADO;
  }

}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/common/activity-list/activity-list.component.ts